import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   * Inicio de sesión
   */
  public login(email: string, password: string): Observable<object> {

    let headers = new HttpHeaders();
    headers = headers.set('x-api-key', this.key);

    const request = {
        email,
        password
    };

    return this.http
               .post(`${this.url}/login`, request, {responseType: 'json', headers})
               .pipe(
                  catchError(this.errorHandler)
               );
  }

  /**
   *
   */
  public logout(): void {

    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('gbi_auth_user');
    localStorage.removeItem('gbi_expires_at');

    // Go back to the login route
    this.router.navigate(['login']);
  }

  /**
   * Inicializa las variables de sessión en el localStorage
   */
  public setSession(authResult): void {

    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expires_at * 1000) + new Date().getTime());
    const authUser  = JSON.stringify(authResult.auth_user);

    localStorage.setItem('gbi_auth_user', authUser);
    localStorage.setItem('gbi_expires_at', expiresAt);
  }

  /**
   *
   */
  public isAuthenticated(): boolean {

      // Comprueba si la hora actual es posterior al tiempo de caducidad
      // del Token de Acceso
      const expiresAt = JSON.parse(localStorage.getItem('gbi_expires_at') || '{}');
      return new Date().getTime() < expiresAt;
      // return true;
  }

  /**
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error);
  }
}
